  const seatFormatMap = new Map([
    [
        'Physical', {
            details: `
            FedEx: 
            The traditional paper or “hard” ticket that has existed for dozens of years. 
            Physical tickets usually include a barcode that must be scanned in order to gain entry to the event.\n
            
            LocalPickup: Physical tickets are generally shipped via FedEx, but in some cases may need to be picked up by the consumer at the venue’s Will Call or a location near the venue. 
            The seller will provide the exact location after the order is accepted.
            `
        }
    ],
    [
        'Eticket', {
            description: `These tickets are generally PDF files that the consumer will download and print out to take to the event and generally include a barcode that must be scanned in order to gain entry to the event.\n

            Sometimes the seller will provide a PDF of the mobile entry ticket images. These must be displayed on a mobile phone so the barcodes can be scanned for entry. The venue will not allow entry if these are printed on paper.`
        }
    ],
    [
        'TM_mobile', {
            description: `	Mobile Entry is rapidly becoming the most prolific way tickets are distributed. The tickets purchased will be transferred to the consumer's email address. The consumer must then accept the transfer and then be prepared to show the tickets on their mobile device in order to gain entry to the event. 
            Learn more from Ticketmaster.
            `
        }
    ],
    [
        'Flash_seats', {
            description: `Flash Seats is very similar to TM Mobile Entry.`
        }
    ],
    [
        'Paperless', {
            description: `
            FedEx: 
            For some events, no actual tickets are issued and instead the credit card that originally purchased the tickets must be scanned in order to gain entry to the event. 
            Learn more from Ticketmaster. 
            In most cases a gift card with instructions will be sent to the consumer via FedEx and the consumer will use that gift card to gain entry to the event. The gift card does not need to be returned after the event and may be discarded.\n

            LocalPickup: 
            In some cases it may be too late to ship the gift card required for entry and the Client may need to be picked up by the consumer at the venue’s Will Call or a location near the venue. The seller will provide the exact location after the order is accepted.\n

            Paperless: 
            In other cases the consumer may need to meet a representative of the company selling the tickets at the venue and the representative will walk the consumer through the process of entering the event.\n
            `
        }
    ],
]);

export default {
    seatFormatMap,
     
  }

  